import {lazy} from 'react';

export const SpecialistCabinetAsync = lazy(() =>
    import('./SpecialistCabinet')
);
